import components from './components'
import computed from './computed'
import methods from './methods'
import mounted from './mounted'

export default {
  components,
  computed,
  methods,
  resourcePath: 'v1/search-engine/search',
  mounted
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/resources/index.js